<div class="modal-header">
    <div class="modal-title">Financial documentation assistant</div>

    <button id="ist-help-close-btn" type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <div class="row mb-3">
        <div class="col-lg-3 col-md-4 accordion-container">

            <accordion [isAnimated]="true" [closeOthers]="true">

                <accordion-group heading="Federal tax return Form 1120S" [isOpen]="activeBtn > 0 && activeBtn < 7">
                    <button id="show-help-details-1" class="item" [class.active]="activeBtn == 1" (click)="showHelpDetails(1)">
                        <small>Revenue</small>
                    </button>
                    <button id="show-help-details-2" class="item" [class.active]="activeBtn == 2" (click)="showHelpDetails(2)">
                        <small>Profit before Taxes</small>
                    </button>
                    <button id="show-help-details-3" class="item" [class.active]="activeBtn == 3" (click)="showHelpDetails(3)">
                        <small>Interest</small>
                    </button>
                    <button id="show-help-details-4" class="item" [class.active]="activeBtn == 4" (click)="showHelpDetails(4)">
                        <small>Depreciation</small>
                    </button>
                    <button id="show-help-details-5" class="item" [class.active]="activeBtn == 5" (click)="showHelpDetails(5)">
                        <small>Amortization</small>
                    </button>
                    <button id="show-help-details-6" class="item" [class.active]="activeBtn == 6" (click)="showHelpDetails(6)">
                        <small>All Owner(s)’s Compensation</small>
                    </button>
                </accordion-group>

                <accordion-group heading="Federal tax return Form 1120" [isOpen]="activeBtn > 6 && activeBtn < 13">
                    <button id="show-help-details-7" class="item" [class.active]="activeBtn == 7" (click)="showHelpDetails(7)">
                        <small>Revenue</small>
                    </button>
                    <button id="show-help-details-8" class="item" [class.active]="activeBtn == 8" (click)="showHelpDetails(8)">
                        <small>Profit before Taxes</small>
                    </button>
                    <button id="show-help-details-9" class="item" [class.active]="activeBtn == 9" (click)="showHelpDetails(9)">
                        <small>Interest</small>
                    </button>
                    <button id="show-help-details-10" class="item" [class.active]="activeBtn == 10" (click)="showHelpDetails(10)">
                        <small>Depreciation</small>
                    </button>
                    <button id="show-help-details-11" class="item" [class.active]="activeBtn == 11" (click)="showHelpDetails(11)">
                        <small>Amortization</small>
                    </button>
                    <button id="show-help-details-12" class="item" [class.active]="activeBtn == 12" (click)="showHelpDetails(12)">
                        <small>All Owner(s)’s Compensation</small>
                    </button>
                </accordion-group>

                <accordion-group heading="Federal tax return Form 1065" [isOpen]="activeBtn > 12 && activeBtn < 20">
                    <button id="show-help-details-13" class="item" [class.active]="activeBtn == 13" (click)="showHelpDetails(13)">
                        <small>Revenue</small>
                    </button>
                    <button id="show-help-details-14" class="item" [class.active]="activeBtn == 14" (click)="showHelpDetails(14)">
                        <small>Profit before Taxes</small>
                    </button>
                    <button id="show-help-details-15" class="item" [class.active]="activeBtn == 15" (click)="showHelpDetails(15)">
                        <small>Interest</small>
                    </button>
                    <button id="show-help-details-16" class="item" [class.active]="activeBtn == 16" (click)="showHelpDetails(16)">
                        <small>Depreciation</small>
                    </button>
                    <button id="show-help-details-17" class="item" [class.active]="activeBtn == 17" (click)="showHelpDetails(17)">
                        <small>Amortization</small>
                    </button>
                    <button id="show-help-details-18" class="item" [class.active]="activeBtn == 18" (click)="showHelpDetails(18)">
                        <small>All Owner(s)’s Compensation</small>
                    </button>
                    <button id="show-help-details-19" class="item" [class.active]="activeBtn == 19" (click)="showHelpDetails(19)">
                        <small>Guaranteed Payments to Partners</small>
                    </button>
                </accordion-group>

                <accordion-group heading="Schedule C (Federal tax return Form 1040)" [isOpen]="activeBtn > 19 && activeBtn < 26">
                    <button id="show-help-details-20" class="item" [class.active]="activeBtn == 20" (click)="showHelpDetails(20)">
                        <small>Revenue</small>
                    </button>
                    <button id="show-help-details-21" class="item" [class.active]="activeBtn == 21" (click)="showHelpDetails(21)">
                        <small>Profit before Taxes</small>
                    </button>
                    <button id="show-help-details-22" class="item" [class.active]="activeBtn == 22" (click)="showHelpDetails(22)">
                        <small>Interest</small>
                    </button>
                    <button id="show-help-details-23" class="item" [class.active]="activeBtn == 23" (click)="showHelpDetails(23)">
                        <small>Depreciation</small>
                    </button>
                    <button id="show-help-details-24" class="item" [class.active]="activeBtn == 24" (click)="showHelpDetails(24)">
                        <small>Amortization</small>
                    </button>
                    <button id="show-help-details-25" class="item" [class.active]="activeBtn == 25" (click)="showHelpDetails(25)">
                        <small>All Owner(s)’s Compensation</small>
                    </button>
                </accordion-group>

                <accordion-group heading="Internal or CPA produced Financial Form" [isOpen]="activeBtn > 25 && activeBtn < 32">
                    <button id="show-help-details-26" class="item" [class.active]="activeBtn == 26" (click)="showHelpDetails(26)">
                        <small>Revenue</small>
                    </button>
                    <button id="show-help-details-27" class="item" [class.active]="activeBtn == 27" (click)="showHelpDetails(27)">
                        <small>Profit before Taxes</small>
                    </button>
                    <button id="show-help-details-28" class="item" [class.active]="activeBtn == 28" (click)="showHelpDetails(28)">
                        <small>Interest</small>
                    </button>
                    <button id="show-help-details-29" class="item" [class.active]="activeBtn == 29" (click)="showHelpDetails(29)">
                        <small>Depreciation</small>
                    </button>
                    <button id="show-help-details-30" class="item" [class.active]="activeBtn == 30" (click)="showHelpDetails(30)">
                        <small>Amortization</small>
                    </button>
                    <button id="show-help-details-31" class="item" [class.active]="activeBtn == 31" (click)="showHelpDetails(31)">
                        <small>All Owner(s)’s Compensation</small>
                    </button>
                </accordion-group>

            </accordion>

        </div>
        <div class="col-lg-9 col-md-8" *ngIf="helpImageSrc">
            <div class="row">
                <div class="col-md-12 mb-3 font-weight-bold font-size-20">
                    {{helpInstruction}}
                </div>
            </div>
            <div class="help-image">
                <img [src]="helpImageSrc" alt="...">
            </div>
        </div>

    </div>
</div>
